import { h, Component } from 'preact';
import * as BaseComp from 'components/bolt/hub/components/carousel/carousel.js';
// import s from 'components/bolt/hub/components/carousel/carousel.sss';
import { accessNested, joinClasses, sortObjectByOrder } from 'utils/utils';
import { smoothScrollTo } from 'utils/smoothScroll';
import Tile from 'components/bolt/hub/components/carousel/tile';
import CarouselArrow from 'components/bolt/icons/carouselArrow';
import Store from 'store/store';
import s from 'components/bolt/hub/components/carousel/carousel.sss';
import { onMarkdownClick } from 'utils/bolt';
import HTML from 'components/core/html/html.js';
import { getPlaylistData } from 'services/boltYoutube';
import { linkOut, navigateInternally, getPageFromVideoId } from 'utils/bolt';
import HubTextOverlay from 'components/bolt/hub/components/hubTextOverlay/hubTextOverlay';
import { observeScroll, unobserveScroll } from 'utils/scrollObserver';
import { getDynamicData } from 'utils/bolt/dynamicData';

const addKey = (item, key) => {
	if (item && typeof item === 'object') {
		if (item.toJS) item = item.toJS();
		item.key = key;
	}
	return item;
};

// Hardcode mapping of section IDs to playlist IDs

const encodedCharacters = ['~', '|', '\n'];
const decodeRegex = new RegExp(`~([0-${encodedCharacters.length - 1}])`, 'g');
const decode = str => str.replace(decodeRegex, (_, i) => encodedCharacters[i]);

export default class Carousel extends BaseComp.default {
	constructor(props) {
		super(props);
		this.onDragStart = this.onDragStart.bind(this);
		this.onDragMove = this.onDragMove.bind(this);
		this.onDragEnd = this.onDragEnd.bind(this);
		this.onSideScroll = this.onSideScroll.bind(this);
		this.state = {
			scrollStart: true,
			scrollEnd: false,
			dragging: false,
			dragDistance: 0,
			currentTileIndex: 0,
			dynamicData: null
		};

		this.videos = [];
		this.customList = [];
		this.getVideosFromPlaylist = this.getVideosFromPlaylist.bind(this);
		//his.renderCustomItem = this.renderCustomItem.bind(this);
		this.defineVideoList = this.defineVideoList.bind(this);
		// console.log('carousel page props', this.props);
		this.pageData = accessNested(this.props, `appData.pages.${'myUniversalStory'}.data`, {});
		// console.log('carousel page data', this.props?.data?.youTubePlaylistId);



		const videosPageData = Store.get().appData?.pages?.boltVideos?.data?.list || [];
		const videosList = sortObjectByOrder(videosPageData, addKey);
		const customList = sortObjectByOrder(this.pageData.list, addKey);


		this.generateVideoLists(videosList, customList);
		this.toggleTextOverlay = this.toggleTextOverlay.bind(this);
		this.onHostedClick = this.onHostedClick.bind(this);
		this.textOverlay = 'test';
	}



	async componentDidMount() {
		window.addEventListener('mouseup', this.onDragEnd);
		observeScroll(this.base, { once: true });

		const { appData } = Store.get();
		if (appData?.options?.cmsManaged) {
			const pageId = this.props.id;
			const landingData = await getDynamicData('landing');


			const sectionData = landingData.playlists?.[pageId.replace(/^home([A-Z])/, (_, c) => c.toLowerCase())];
			if (sectionData) {
				this.setState({ dynamicData: sectionData }, async () => {
					const videosPageData = Store.get().appData?.pages?.boltVideos?.data?.list || [];
					const videosList = sortObjectByOrder(videosPageData, addKey);
					const customList = sortObjectByOrder(this.pageData.list, addKey);

					await this.generateVideoLists(videosList, customList);
				});
			} else {
				console.warn('No dynamic data found for', pageId);
				const videosPageData = Store.get().appData?.pages?.boltVideos?.data?.list || [];
				const videosList = sortObjectByOrder(videosPageData, addKey);
				const customList = sortObjectByOrder(this.pageData.list, addKey);

				await this.generateVideoLists(videosList, customList);
			}
		}
	}

	componentWillUnmount() {
		window.removeEventListener('mouseup', this.onDragEnd);

		unobserveScroll(this.base);
	}

	async loadCustomData(dynamicData) {
		if (!dynamicData) {
			return;
		}
		const { appData } = Store.get();
		if (!appData?.options?.cmsManaged || !dynamicData) return;
	}


	async generateVideoLists(videosList, customList) {
		this.videos = await this.defineVideoList(videosList);
		this.customList = await this.defineVideoList(customList);

		const hasCustomList = this.customList.length > 0;
		const hasVideos = this.videos.length > 0;
		const showDummy = hasCustomList ? (this.customList.length === 2) : (this.videos.length === 2);
		const hideSection = (!hasCustomList && !hasVideos) || (hasCustomList && this.customList.length < 2) || (hasVideos && !hasCustomList && this.videos.length < 2);
		if (hideSection) {
			Store.emit('WATCH_MORE_HIDDEN', this.props.id);
		}

		this.setState({
			hideSection,
			showDummy,
			showLoader: false
		});
	}

	async defineVideoList(videos) {

		let newVideos = [];
		try {
			//let promises = videos.map(vid => vid?.youtubePlaylistId ? this.getVideosFromPlaylist(vid) : vid);
			let promises = videos.map(vid => this.getVideosFromPlaylist(vid) );

			let data = await Promise.all(promises);
			const concatArray = [].concat(...data);
			newVideos = concatArray;
		} catch (e) {
			newVideos = this.removeYoutubePlaylists(videos);
		}
		return newVideos;
	}

	async getVideosFromPlaylist(vid) {
		//'PLuq_rgCzEP_Nwi0LlH_i-v9z1i7UVE2Lb';
		const playlistId =
			this.state.dynamicData?.playlistId || this.props?.data?.youTubePlaylistId;
		const noCookies = vid.noCookies;
		let data = await getPlaylistData(playlistId);
		return data.items.filter(item => item.snippet.thumbnails.medium).sort((a, b) => this.sortPlaylist(a, b, vid.playlistOrder)).map(item => ({
			name: item.snippet.title,
			thumbSrc: item.snippet.thumbnails.medium.url,
			youtubeId: item.snippet.resourceId.videoId,
			key: item.id,
			noCookies
		}));
	}

	removeYoutubePlaylists = (array) => {
		return array.filter((item) => !item['youtubePlaylistId'] && item );
	};

	sortPlaylist(a, b, order) {
		if (!order) {
			return 0;
		}
		const playlistOrder = order.replace(/\s/g, '').split(',').reverse();

		return playlistOrder.indexOf(b.snippet.resourceId.videoId) - playlistOrder.indexOf(a.snippet.resourceId.videoId);
	}

	onCustomItemClick(link, forceSameWindow, videoID) {
		if (videoID) {
			Store.get().videos.set({ preSelected: videoID });
			const pageId = getPageFromVideoId(videoID);
			return Store.emit('OPEN_VIDEO_OVERLAY', pageId);
		} else {
			if (Object.values(this.props.appData.pages).find(page => page.id === link)) {
				navigateInternally(link);
			} else {
				linkOut(link, forceSameWindow ? '_self' : '_blank');
			}
		}
	}

	onDragStart(e) {
		e.preventDefault();
		this.setState({ dragging: true });
		this.mousePosX = e.clientX;
	}


	onDragMove(e) {
		if (!this.state.dragging) return;
		this.setState({ dragDistance: this.state.dragDistance + 1 });
		e.preventDefault();
		this.$sideScroller.scrollLeft = this.$sideScroller.scrollLeft + (this.mousePosX - e.clientX);
		this.mousePosX = e.clientX;
	}

	onDragEnd() {
		setTimeout(() => {
			this.setState({ dragging: false, dragDistance: 0 });
		}, 50);
	}

	componentDidUpdate(prevProps) {
		if (this.props.clientDimensions.width !== prevProps.clientDimensions.width) {
			this.updateScrollPosition();
		}
	}

	updateScrollPosition() {
		if (this.$sideScroller.scrollLeft <= 0) {
			this.setState({
				scrollStart: true
			});
		} else if (Math.ceil(this.$sideScroller.scrollLeft) >= (this.carousel.clientWidth - this.props.clientDimensions.width)) {
			this.setState({
				scrollEnd: true
			});
		} else {
			if (this.state.scrollStart || this.state.scrollEnd) {
				this.setState({
					scrollStart: false,
					scrollEnd: false
				});
			}
		}
	}

	updateCurrentTileIndex() {
		const { data } = this.props;
		const firstTile = document.getElementById(`${data.anchor}-0`);
		const { left, width } = firstTile.getBoundingClientRect();
		const index = Math.abs(Math.round(left / width));
		this.setState({
			currentTileIndex: index
		});
	}

	onSideScroll() {
		this.updateScrollPosition();
		this.updateCurrentTileIndex();
	}

	handleArrowClick(direction, numTiles, paddingOffset, e) {
		if (e) {
			e.preventDefault();
		}
		const { scrollStart, scrollEnd, currentTileIndex } = this.state;
		const { data, clientDimensions } = this.props;

		if (direction === 'prev' && scrollStart) return;
		if (direction === 'next' && scrollEnd) return;

		if (direction === 'prev') {
			if (currentTileIndex === 0) {
				smoothScrollTo(this.$sideScroller, 0, 300, { direction: 'hor' });
			} else {
				let prevTile = document.getElementById(`${data.anchor}-${currentTileIndex - 1}`);
				const isWideDesktop = Store.get().client?.dimensions?.width > 1280;
				let tileOnTheLeft = prevTile ?
					Math.floor((this.$sideScroller.scrollLeft - (isWideDesktop ? 70 : 30)) / (prevTile.getBoundingClientRect().width + (isWideDesktop ? 40 : 20))) :
					Math.floor((this.$sideScroller.scrollLeft - (isWideDesktop ? 70 : 30)) / (+ (isWideDesktop ? 40 : 20)));
				if (currentTileIndex >= tileOnTheLeft) {
					prevTile = document.getElementById(`${data.anchor}-${tileOnTheLeft}`);
				}

				smoothScrollTo(this.$sideScroller, prevTile, 300, { direction: 'hor', offset: paddingOffset });
			}
		}

		if (direction === 'next') {
			if (currentTileIndex >= numTiles - 1) {
				const maxScroll = this.carousel.clientWidth - clientDimensions.width;
				smoothScrollTo(this.$sideScroller, maxScroll, 300, { direction: 'hor' });
			} else {
				const nextTile = document.getElementById(`${data.anchor}-${currentTileIndex + 1}`);
				smoothScrollTo(this.$sideScroller, nextTile, 300, { direction: 'hor', offset: paddingOffset });
			}
		}
	}

	onHostedClick() {
		this.toggleTextOverlay(true);
		Store.emit('CUSTOM_EVENT', {
			category: this.props.id,
			action: 'jacqueline-overlay-click',
		});
		return;
	}

	toggleTextOverlay(open) {
		this.setState({
			textOverlayOpen: open
		});
		Store.emit('CAROUSEL_TEXT_OVERLAY_SHOW', open ? this.props.carouselId : null);
	}

	renderTextOverlay(textOverlay) {
		if (!textOverlay) return;
		const show = this.state.textOverlayOpen;

		return (
			<HubTextOverlay
				content={textOverlay}
				show={show}
				closeOverlay={() => this.toggleTextOverlay()}
			/>
		);
	}

	onSubheadingClick(data, id) {
		const match = data.subheading.match(/href="(.*?)"/);
		const destination = match ? match[1] : null;
		if (destination != null) {

			Store.emit('CUSTOM_EVENT', {
				category: id,
				action: 'external-link-tout-click',
				label: destination
			});
		}
	}

	transformOverlayLink(link, name, img) {
		if (!link || typeof link !== 'string') return '';

		if (link.startsWith('text-overlay:')) {
			const overlayStr = link.substring('text-overlay:'.length);
			const [rawText, rawImg] = overlayStr.split('|');

			const decode = str => str.replace(/~2/g, '\n');
			const decodedText = decode(rawText || '');
			const decodedImg = decode(rawImg || img || '');

			// Extract name part (between ** **) and description
			const nameMatch = decodedText.match(/\*\*(.*?)\*\*/);
			const personName = nameMatch ? nameMatch[1] : name;
			const description = decodedText.replace(/\*\*.*?\*\*/, '').trim();

			// Build HTML string
			return `
				<img src="${decodedImg}" alt="Photo of ${personName}" />
				<div>
					<h2>${personName}</h2>
					<p>${description}</p>
				</div>
				`;
		}

		// fallback
		return link;
	}

	render({ data, index, clientDimensions, useTileSlantyTag, fallbackFormat }) {
		if (!data) return;
		const isOddIndex = index % 2 === 1;
		const dynamicData = this.state.dynamicData;
		const carouselData = {
			...data,
			heading: dynamicData?.name || data.heading,
			subheading: dynamicData?.description || data.subheading,
			hosted: dynamicData?.hostedBy
				? {
					copy: `${dynamicData.hostedBy.title} <b><u>${dynamicData.hostedBy.name}</u></b>`,
					asset: dynamicData.hostedBy.image,
					alt: dynamicData.hostedBy.name,
					textOverlay: this.transformOverlayLink(
						dynamicData.hostedBy.link,
						dynamicData.hostedBy.name,
						dynamicData.hostedBy.image
					)
				}
				: data.hosted,
			youTubePlaylistId: dynamicData?.playlistId || (data.youTubePlaylistId || 'PLuq_rgCzEP_Ne0W0nk6R66sYFGr1Jrzqe')
		};
		const tag = carouselData.tag;
		//const tiles = sortObjectByOrder(carouselData.tiles);
		const tiles = sortObjectByOrder(carouselData.tiles);
		const { scrollStart, scrollEnd } = this.state;
		const carouselStyle = this.carousel && window.getComputedStyle(this.carousel);
		const carouselPaddingRight = carouselStyle && carouselStyle.getPropertyValue('padding-right').replace(/px/, '');
		const needsScroll = this.carousel && (clientDimensions.width < (this.carousel.clientWidth - carouselPaddingRight));
		const anchor = carouselData.anchor || 'top';
		const carouselId = carouselData.anchor || carouselData.heading || 'top';

		const hasTextOverlayOpen = Store.get()?.hub?.carouselWithTextOverlayOpen === carouselId;

		const isHosted = !!carouselData.hosted;
		const textOverlayContent = carouselData?.hosted?.textOverlay;
		return (
			<div class={joinClasses(s.container, isOddIndex && s.containerOddBgColor, hasTextOverlayOpen && s.hasTextOverlayOpen)} data-hash-wrapper={anchor} id={carouselId}>
				<div class={joinClasses(s.header)}>
					<h3 class="h3">{carouselData.heading}</h3>
					{!isHosted && needsScroll && (
						<div class={s.arrows}>
							<CarouselArrow
								class={joinClasses(s.left, scrollStart && s.inactive)}
								onClick={() => this.handleArrowClick('prev', tiles.length, carouselPaddingRight)}
								onTouchEnd={(e) => this.handleArrowClick('prev', tiles.length, carouselPaddingRight, e)}
							/>
							<CarouselArrow
								class={joinClasses(s.right, scrollEnd && s.inactive)}
								onClick={() => this.handleArrowClick('next', tiles.length, carouselPaddingRight)}
								onTouchEnd={(e) => this.handleArrowClick('next', tiles.length, carouselPaddingRight, e)}
							/>
						</div>
					)}
					{tag && <div class={joinClasses(s.tags, 'mediumB')}> {tag.toUpperCase()}</div>}
				</div>
				{carouselData.subheading && <HTML tag="h4" markdown content={carouselData.subheading} class={s.subheading} onClickCapture={() => this.onSubheadingClick(data, this.props.id)} />}
				{isHosted && needsScroll && (
					<div class={s.hostedWrapper}>
						<div class={s.hosted}>
							<div class={s.imageWrapper}><img src={carouselData.hosted?.asset} alt={carouselData.hosted?.alt} class={s.hostedAsset} /></div>
							<HTML tag="p" markdown content={carouselData.hosted?.copy} class={s.hostedLabel} onClickCapture={this.onHostedClick} />
						</div>
						<div class={joinClasses(s.arrows, s.hostedArrows)}>
							<CarouselArrow
								class={joinClasses(s.left, scrollStart && s.inactive)}
								onClick={() => this.handleArrowClick('prev', tiles.length, carouselPaddingRight)}
								onTouchEnd={(e) => this.handleArrowClick('prev', tiles.length, carouselPaddingRight, e)}
							/>
							<CarouselArrow
								class={joinClasses(s.right, scrollEnd && s.inactive)}
								onClick={() => this.handleArrowClick('next', tiles.length, carouselPaddingRight)}
								onTouchEnd={(e) => this.handleArrowClick('next', tiles.length, carouselPaddingRight, e)}
							/>
						</div>
					</div>
				)}
				<div
					class={s.sideScroller}
					ref={ref => this.$sideScroller = ref}
					onMouseDown={this.onDragStart}
					onMouseMove={this.onDragMove}
					onScroll={this.onSideScroll}
				>
					<div
						class={s.carousel}
						ref={ref => this.carousel = ref}
					>
						{!!this.videos.length && this.videos.map((video, i) => (
							<Tile
								key={i}
								carouselTitle={anchor}
								id={`${anchor}-${i}`}
								data={video}
								carouselHeader={carouselData.heading}
								useTileSlantyTag={useTileSlantyTag}
								fallbackFormat={fallbackFormat}
								carouselId={carouselId}
								isHubCarousel={this.props.isHubCarousel}
								dragging={this.state.dragDistance > 10}
								verticalLayout={carouselData.verticalLayout || false}
								parentId={this.props.id}
							/>
						)
						)}
					</div>
				</div>
				{isHosted && textOverlayContent && this.renderTextOverlay(textOverlayContent)}
			</div>
		);
	}
}
